// ================================
// PINCODE CHECKER (AJAX SAFE)
// ================================

(function ($) {
  if (!$) return;

  const API_URL =
    "https://script.google.com/macros/s/AKfycby2qL1P5dD2iTLCd_W53MdC-DoSkNBUNmMDuwQPMZqbVEogI1_PWSPtqcWUBH5r9KVc/exec";

  const pincodeCache = {};

  function formatShortDate(dateStr) {
    if (!dateStr) return "";
    return dateStr.split(", ")[1];
  }

  // 🔥 EVENT DELEGATION (THIS IS THE FIX)
  $(document).on("click", ".delivery-checker__check-btn", function (e) {
    e.preventDefault();

    const $button = $(this);
    const $section = $button.closest(".delivery-checker");

    if (!$section.length) return;

    const $input = $section.find(".delivery-checker__input");
    const $dateEl = $section.find(".delivery-checker__date");
    const $result = $section.find(".delivery-checker__result");
    const $cash = $section.find(".delivery-checker__info-item");
    const $label = $section.find(".delivery-checker__label");
    const $dicon = $section.find(".delivery-icon");
    const $errormsg = $section.find(".error_message");

    const pincode = $.trim($input.val());

    // Reset UI
    $result.show();
    $cash.hide();
    $label.hide();
    $dicon.hide();
    $errormsg.hide();
    $dateEl.text("");
    $input.css("border", "1px solid #dcdcdc");

    // Validation
    if (!/^\d{6}$/.test(pincode)) {
      $errormsg.text("Please enter a valid 6-digit pincode").show();
      $input.css("border", "1px solid red");
      return;
    }

    // Cache check
    if (
      pincodeCache[pincode] &&
      pincodeCache[pincode].expectedDateMin &&
      pincodeCache[pincode].expectedDateMax
    ) {
      const cached = pincodeCache[pincode];

      $label.text("Estimated delivery date by").show();
      $dicon.show();

      $dateEl.text(
        formatShortDate(cached.expectedDateMin) +
          " - " +
          formatShortDate(cached.expectedDateMax)
      );

      $cash.show();
      return;
    }

    // Loading state
    $button.prop("disabled", true).addClass("is-loading");
    $input.prop("disabled", true);

    $label.text("Estimated delivery date by").show();
    $dicon.show();
    $dateEl.html('<span class="loader"></span> Checking...');

    // API call
    $.ajax({
      url: API_URL,
      method: "GET",
      data: { pincode },
      dataType: "json",

      success: function (data) {
        if (data.expectedDateMin && data.expectedDateMax) {
          pincodeCache[pincode] = data;

          $dateEl.text(
            formatShortDate(data.expectedDateMin) +
              " - " +
              formatShortDate(data.expectedDateMax)
          );

          $cash.show();
        } else {
          delete pincodeCache[pincode];
          $dateEl.text("");
          $label.text("Delivery not available").show();
          $cash.hide();
        }
      },

      error: function () {
        delete pincodeCache[pincode];
        $dateEl.text("");
        $label.text("Delivery not available").show();
        $cash.hide();
      },

      complete: function () {
        $button.prop("disabled", false).removeClass("is-loading");
        $input.prop("disabled", false);
      }
    });
  });
})(window.jQuery);
